import React, { useEffect } from 'react'
import { useParams, useNavigate, useLocation } from 'react-router-dom'

const withRouter = (Component) => {
    return props => {
        return (
            <div className='appearance_in'>
                <Component
                    {...props}
                    location={useLocation()}
                    params={useParams()}
                    navigate={useNavigate()}
                />
            </div>
        )
    }
}

export default withRouter